var _ = require('lodash');
var CongratulationsConstants = require('../constants/CongratulationsConstants');
var AppConstants = require('../constants/ApplicationConstants');
var FyConstants = require('../constants/FundingYourProductConstants');
var YdConstants = require('../constants/YourDetailsConstants');
var AccountTypes = AppConstants.AccountTypeCodes;
var RollOverTypes = FyConstants.RollOverTypes;
var TrusteeType = YdConstants.TrusteeType;
var additionalInvestorForm = CongratulationsConstants.additionalInvestorForm;

function getMultipleFormArray(times, data) {
    return _.times(times, function (idx) {
        let newData = _.clone(data);
        newData.value = `${newData.value}__${(idx + 1)}`;
        return newData;
    });
}

module.exports = {
    getKycForms: function (formList, names) {
        if (!formList || !formList.length || formList.length < 1 || !names || !names.length || names.length < 2) {
            return;
        }

        let individualKyc = _.find(formList, { value: 'individualKyc' });
        if (!individualKyc) {
            return;
        }

        let kycList = getMultipleFormArray(names.length, individualKyc);
        if (kycList) {
            _.forEach(names, function (name, idx) {
                kycList[idx].name = name;
            });
            return { forms: kycList, index: formList.indexOf(individualKyc) }
        }
    },

    getDirectDebitAuthorithyForms: function (application, formList) {
        let newDda = [];
        let dda = _.find(formList, (f) => { return _.startsWith(f.value, 'dda') });
        if (!dda) {
            return;
        }

        if (application && application.form && application.form.fundingYourProduct && application.form.regularInvestmentPlan) {
            let fundingBankAccount = '', fyBankDetail = [], ripBankAccount = '';
            if (application.form.fundingYourProduct.fundingSources && application.form.fundingYourProduct.fundingSources.length > 0) {
                fyBankDetail = _.where(application.form.fundingYourProduct.fundingSources, { bankAccountHeldOption: AppConstants.YesNoValues.NO });
                if (fyBankDetail.length > 0) {
                    fundingBankAccount = fyBankDetail[0].accountNumber;
                }
            }

            if (application.form.regularInvestmentPlan.bankAccount &&
                application.form.regularInvestmentPlan.bankAccountHeldOption ===
                AppConstants.YesNoValues.NO) {
                ripBankAccount = application.form.regularInvestmentPlan.bankAccount;
            }

            if (ripBankAccount.length > 0 && fundingBankAccount.length > 0) {
                if (ripBankAccount !== fundingBankAccount) {
                    newDda = getMultipleFormArray(2, dda);
                    newDda[0].name = fundingBankAccount;
                    newDda[1].name = ripBankAccount;
                    return { forms: newDda, index: formList.indexOf(dda) };
                } else {
                    newDda = getMultipleFormArray(2, dda);
                    newDda[0].name = fundingBankAccount;
                    newDda[1].name = fundingBankAccount;
                    return { forms: newDda, index: formList.indexOf(dda) };
                }
            }
            else if (fundingBankAccount.length > 0) {
                newDda = getMultipleFormArray(1, dda);
                newDda[0].name = fundingBankAccount;
                return { forms: newDda, index: formList.indexOf(dda) };
            }
            else if (ripBankAccount.length > 0) {
                newDda = getMultipleFormArray(1, dda);
                newDda[0].name = ripBankAccount;
                return { forms: newDda, index: formList.indexOf(dda) };
            }
        }
    },

    getAdditionalApplicationFormList: function (formModel) {
        if (!formModel || !formModel.form) {
            return;
        }
        let yd = formModel.form.yourDetails, accountType = formModel.form.accountType, list = [], applicationForms = [];
        if (yd && accountType) {
            if (accountType === AccountTypes.JOINT) {
                if (yd.investorList && yd.investorList.length && yd.investorList.length > 2) {
                    list = list.concat(_.slice(yd.investorList, 2, yd.investorList.length));
                }
            }
            else {
                if (yd.investorList && yd.investorList.length && yd.investorList.length > 1) {
                    list = list.concat(_.slice(yd.investorList, 2, yd.investorList.length));
                }
                else if (yd.trusteeList && yd.trusteeList.length && yd.trusteeList.length > 1) {
                    list = list.concat(_.slice(yd.trusteeList, 2, yd.trusteeList.length));
                }
            }

            _.forEach(list, function (item, idx) {
                var investor = _.clone(additionalInvestorForm);
                investor.value += `__${(idx + 1)}`;
                investor.name = item.trusteeType == TrusteeType.CORPORATE ? item.corporateTrustee : item.lastName;
                applicationForms.push(investor)
            });

            return applicationForms;
        }
    },

    getConsolidateForms: function (application, formList) {
        let newConsolidate = [];
        let consolidate = _.find(formList, (f) => { return _.startsWith(f.value, 'consolidate') });

        if (application && application.form && application.form.fundingYourProduct) {
            if (application.form.fundingYourProduct.fundingSources && application.form.fundingYourProduct.fundingSources.length > 0) {
                let externalRollovers = _.where(application.form.fundingYourProduct.fundingSources, { rollOverType: RollOverTypes.EXTERNAL });
                if (externalRollovers.length > 5 && externalRollovers.length < 11) {
                    newConsolidate = getMultipleFormArray(2, consolidate);
                    newConsolidate[0].name = null;
                    newConsolidate[1].name = 'Additional';
                    return { forms: newConsolidate, index: formList.indexOf(consolidate) };
                }
                else if (externalRollovers.length > 10 && externalRollovers.length < 16) {
                    newConsolidate = getMultipleFormArray(3, consolidate);
                    newConsolidate[0].name = null;
                    newConsolidate[1].name = 'Additional';
                    newConsolidate[2].name = 'Additional';
                    return { forms: newConsolidate, index: formList.indexOf(consolidate) };
                }
                else if (externalRollovers.length > 15) {
                    newConsolidate = getMultipleFormArray(4, consolidate);
                    newConsolidate[0].name = null;
                    newConsolidate[1].name = 'Additional';
                    newConsolidate[2].name = 'Additional';
                    newConsolidate[3].name = 'Additional';
                    return { forms: newConsolidate, index: formList.indexOf(consolidate) };
                }
            }

        }
    }

}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/CongratulationsHelper.js